import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { useShortUrl, useSessionLinks } from '@app/api';
import { SharableLink } from 'components';
import { useIsAdmin } from 'queries';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  horizontalLinksContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.marginBase + 'px',
  },
  link: {
    maxWidth: theme.marginBase * 25,
  },
  tandemzIcon: {
    color: theme.colors.purple,
    fontSize: theme.iconSize.regular,
  },
}));

interface Props {
  sessionId: string;
}

export const SessionLinks = ({ sessionId }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { data: sessionLinks } = useSessionLinks(sessionId);
  const isAdmin = useIsAdmin();

  const shortUrl = useShortUrl();

  // to still work with already created studies
  if (!sessionLinks || sessionLinks.length === 0) {
    return <SharableLink link={`${shortUrl}/study/${sessionId}`} />;
  }

  const recruitedByTandemzSessionLink = sessionLinks.find(
    (item) => item.recruitmentByTandemz && item.defaultLink,
  );

  const manualRecruitmentSessionLink = sessionLinks.find(
    (item) => !item.recruitmentByTandemz && item.defaultLink,
  );

  return (
    <div className={classes.horizontalLinksContainer}>
      {manualRecruitmentSessionLink && (
        <SharableLink
          link={`${shortUrl}/study/${manualRecruitmentSessionLink.id}`}
          copyButtonVariant="blue"
          className={
            isAdmin &&
            !!recruitedByTandemzSessionLink &&
            recruitedByTandemzSessionLink.id
              ? classes.link
              : ''
          }
        />
      )}
      {isAdmin &&
        !!recruitedByTandemzSessionLink &&
        recruitedByTandemzSessionLink.id && (
          <SharableLink
            link={`${shortUrl}/study/${recruitedByTandemzSessionLink.id}`}
            customIcon={classnames(
              'custom-icon-font-tandemz',
              classes.tandemzIcon,
            )}
            className={classes.link}
            copyButtonVariant="purple"
          />
        )}
    </div>
  );
};
